export default {
  innerSidebarState: false,
  innerSidebarDisabled: false,
  innerSidebar: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/sidebar/state.js